//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import Controller from './Controller'

export default {
  name: 'SearchView',
  props: ['className', 'fieldId', 'url'],
  components: {
    Controller,
  },
  data() {
    return {
      show: true,
      search: '',
      label: this._('Я ищу... '),
    }
  },
  watch: {
    global_search(nval) {
      this.search = nval
    },
  },
  computed: {
    ...mapState('search', [
      'global_search',
    ]),
  },

  mounted() {
    // this.$store.subscribe(mutation => {
    //   if ('search/SET_SEARCH' === mutation.type) {
    //     this.search = mutation.payload
    //   }
    // })
  },
  methods: {
    activateSearch() {
      this.show = false
      this.$nextTick(() => {
        this.focusInput()
      })
    },
    focusInput() {
      const component = this.$refs.searchInput
      if (component) {
        if (component.$el) {
          const input = component.$el.querySelector('input[type="search"]')
          if (input) {
            input.focus()
            return
          }
        }
        if ('function' === typeof component.focus) {
          component.focus()
        }
      }
    },
    // focus() {
    //   this.show = false
    //   this.$nextTick(() => {
    //     // const parent = this.$refs.visibleinput
    //     // let [input] = parent.$children
    //     // input = input.$children[0].$children[0].$children[0].$children[0].$refs.input
    //     //
    //     // if (input.focus) {
    //     //   input.focus()
    //     //   return
    //     // }
    //     // input.$el.focus()
    //   })
    // },
  },
}
